import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NotificationHistory from './NotificationHistory';
import NotificationSettings from './NotificationSettings';
import NotificationTest from './NotificationTest';
import './NotificationPage.css';

const NotificationPage = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('history');

  // Déterminer l'onglet actif selon l'URL
  useEffect(() => {
    if (location.pathname === '/notifications/settings') {
      setActiveTab('settings');
    } else if (location.pathname === '/notifications/test') {
      setActiveTab('test');
    } else {
      setActiveTab('history');
    }
  }, [location.pathname]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === 'settings') {
      navigate('/notifications/settings', { replace: true });
    } else if (tab === 'test') {
      navigate('/notifications/test', { replace: true });
    } else {
      navigate('/notifications/history', { replace: true });
    }
  };

  // Vérifier si on est en mode développement (afficher l'onglet Test)
  // Note: Onglet Test masqué pour la mise en production
  const showTestTab = true;

  return (
    <div className="notifications-page-container">
      {/* Header avec titre et onglets */}
      <div className="notifications-page-header">
        <div className="notifications-page-tabs">
          <button
            onClick={() => handleTabChange('history')}
            className={`notifications-tab ${activeTab === 'history' ? 'active' : ''}`}
          >
            Notifications
          </button>
          <button
            onClick={() => handleTabChange('settings')}
            className={`notifications-tab ${activeTab === 'settings' ? 'active' : ''}`}
          >
            Paramètres
          </button>
          
          {/* Onglet Test - toujours visible pour faciliter les tests */}
          {showTestTab && (
            <button
              onClick={() => handleTabChange('test')}
              className={`notifications-tab ${activeTab === 'test' ? 'active' : ''}`}
            >
              🧪 Test
            </button>
          )}
        </div>
      </div>

      {/* Contenu de l'onglet actif */}
      <div className="notifications-page-content">
        {activeTab === 'history' && (
          <NotificationHistory userId={userId} />
        )}
        {activeTab === 'settings' && (
          <NotificationSettings userId={userId} />
        )}
        {activeTab === 'test' && showTestTab && (
          <NotificationTest userId={userId} />
        )}
      </div>
    </div>
  );
};

export default NotificationPage;
